module.exports = __webpack_public_path__ + "img/shanzhouAppImage.c99f39c2.png";